import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { DispatchContext } from "../../../store";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import { transfersApi } from "../../../services/TransferServices";

const asText = (value) => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") return value?.name ?? value?.code ?? "-";
  return "-";
};

export default function TransferTable({ status, museumId, querySearch }) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [transfers, setTransfers] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getTransfersList();
  }, [querySearch, page, rowsPerPage, museumId]);

  const getTransfersList = () => {
    transfersApi("get", null, {
      search: querySearch,
      state: status,
      page: page,
      per_page: rowsPerPage,
      museum_id: museumId,
    }).then((res) => {
      setTransfers(res?.data);
      setMeta(res?.meta);
    });
  };

  const handleDetail = (id) => {
    navigate(`/management/transfers/${id}`);
  };

  const handleChangePage = (event, newPage) => {
    dispatch({ type: "IS_NOT_LOADING", payload: false });
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: "#B3B3B3" }}>Sl.No.</TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Submission Date
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Accession No.
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Object Name
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Materials
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Recipient Museum Name
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Classification
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transfers?.length > 0 &&
              transfers?.map((transfer, index) => (
                <TableRow key={index} hover onClick={() => handleDetail(transfer?.id)}>
                  <TableCell sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="left">
                    <Moment format={"ll"}>{transfer?.created_at}</Moment>
                  </TableCell>
                  <TableCell align="left">{asText(transfer?.accession_no)}</TableCell>
                  <TableCell align="left">{transfer?.catalogue?.object_name || "-"}</TableCell>
                  <TableCell align="left">{asText(transfer?.catalogue?.material)}</TableCell>
                  <TableCell align="left">{transfer?.recipient_museum_name || "-"}</TableCell>
                  <TableCell align="left">
                    {asText(transfer?.catalogue?.object_group ?? transfer?.catalogue?.classification)}
                  </TableCell>
                  <TableCell align="left" className={"text-capitalize"}>
                    {transfer?.state || "-"}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}
